import React, { useState, useMemo } from "react";

// create context
export const SidebarContext = React.createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const value = useMemo(
    () => ({
      isSidebarOpen,
      setSidebarOpen: setIsSidebarOpen,
      toggleSidebar: () => setIsSidebarOpen(!isSidebarOpen),
      closeSidebar: () => setIsSidebarOpen(false),
    }),
    [isSidebarOpen]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
